// extracted by mini-css-extract-plugin
module.exports = {"root":"BannersBox_root__9P2Wi","item":"BannersBox_item__5YTBR"};